import { useState } from "react"

function useCustomState(initialValue){
    const [value, handleChange] = useState(initialValue)
    return({
        value: value,
        handleChange: handleChange
    })   
}

export default useCustomState